export const tooltipConstants = {
  infoMessage: `Schwab's automatic mutual fund investing allows you to create instructions for purchasing or selling mutual funds for an account on a recurring basis.

    Recurring mutual fund instructions are sent as live orders on their next execution dates. In the event that an instruction lands on a weekend or holiday, it will be processed on the next mutual fund trading day during normal processing times.

    In the event that funds are not available, the order may be rejected and the instructions will be stopped.`,
  mutualFundTooltipMsg: `You can only create one recurring instruction per fund in an account.

    To make changes or cancel an existing instruction, select the fund you want to edit and you'll be provided with options to modify it.`,

  frequencyTootipMsg: `Transaction dates that fall outside of the available days in a month will be performed on the last day of that month.

    If a transaction falls on a day that markets are closed, the transaction will automatically be performed on the next day they open.`
};
